'use strict';

var AlertsDrawerGridTransformerFactory = function AlertsDrawerGridTransformerFactory(DataTransformer) {
  function AlertsDrawerGridTransformer() {
    DataTransformer.call(this);
    this.targetType = 'alerts-drawer-grid';
    this.priority = 1;
  }
  AlertsDrawerGridTransformer.prototype = Object.create(DataTransformer.prototype);
  AlertsDrawerGridTransformer.constructor = AlertsDrawerGridTransformer;
  AlertsDrawerGridTransformer.prototype.canTransform = function (sourceType, targetType) {
    return this.targetType === targetType;
  };
  AlertsDrawerGridTransformer.prototype.isCacheable = function () {
    return false;
  };
  AlertsDrawerGridTransformer.prototype.getCacheKey = function () {
    return this.sourceType + '-' + this.targetType;
  };
  AlertsDrawerGridTransformer.prototype.transform = function (data) {
    return data.domain;
  };
  return AlertsDrawerGridTransformer;
};
AlertsDrawerGridTransformerFactory.$inject = ['DataTransformerFactory'];
module.exports = AlertsDrawerGridTransformerFactory;